import React, { useEffect, useState } from 'react';

import open from '../files/open.png';


function Projects() {
    const [projects, setProjects] = useState([])
    const [details, setDetails] = useState({})
    useEffect(() => {
        fetch('projects.json')
            .then(res => res.json())
            .then(data => setProjects(data))
    }, [])

    const viewDetails = (id) => {
        if (id) {
            setDetails(projects[id - 1])
        }

    }


    return (
        <div id='projects' className='bg-[#242526]'>
            <h3 data-aos="fade-up" data-aos-duration="1500" className='text-center lg:text-5xl text-3xl text-[#17A875]  p-10 font-bold'>Projects</h3>
            <div className='grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4 lg:gap-12  pb-16 lg:mx-20 md:mx-10'>
                {
                    projects?.map(project => <>

                        <div data-aos="flip-right" data-aos-duration="2000" className='lg:my-0 my-4 w-[300px]  bg-[#18191A]   rounded mx-auto   p-3 card'>
                            <div className='overflow-hidden'>
                                <img className='cardImage' src={project?.img} alt='' />
                            </div>
                            <div>
                                <p className='  text-white py-2'>{project?.name}</p>
                                <p className='text-sm text-gray-400'>{project?.details?.slice(0, 120)} ... ... </p>
                                <label onClick={() => viewDetails(project?.id)} for="my-modal-5" className='inline-flex  text-white  bg-[#242526] border-0 hover:bg-[#17A875]  mt-3 px-4 py-2 rounded '>View more <img className='w-4 h-4 ml-3 mt-1' src={open} alt='' /></label>
                            </div>
                        </div>

                    </>)
                }
            </div>


            <input type="checkbox" id="my-modal-5" className="modal-toggle" />
            <div className="modal ">
                <div className="modal-box lg:w-full sm:mx-5  lg:max-w-5xl   bg-[#242526] border-2 border-[#17A875] text-white">
                    <label for="my-modal-5" className="btn btn-sm border-2 border-[#242526] btn-circle bg-accent hover:bg-[#242526] absolute right-2 top-2">✕</label>
                    <h3 className="font-bold text-2xl  mb-4  text-center">{details?.name}</h3>
                    <div className=''>
                        <div className='lg:grid grid-cols-2 gap-5'>
                            <img className='w-full mb-3 rounded-sm' src={details.img} alt='' />
                            <img className='w-full mb-3 rounded-sm' src={details.img2} alt='' />
                            <img className='w-full mb-3 rounded-sm' src={details.img3} alt='' />
                            <img className='w-full mb-3 rounded-sm' src={details.img4} alt='' />
                        </div>
                        <div className="">
                            <p className="py-4 pl-4 ">{details.details}</p>
                            <a target='_blank' rel='noreferrer' href={details.live}>
                                <button className='btn  hover:bg-[#17A875]   mr-3 border-2 border-[#17A875]  mt-3'>Visit Live site <img className='w-5 ml-3 ' src={open} alt='' /> </button>
                            </a>
                            <a target='_blank' rel='noreferrer' href={details.client}>
                                <button className='btn  hover:bg-[#17A875]   mr-3 border-2  border-[#17A875]  mt-3'>Client Side Code <img className='w-5 ml-3  ' src={open} alt='' /> </button>
                            </a>
                            <a target='_blank' rel='noreferrer' href={details.server}>
                                <button className='btn  hover:bg-[#17A875]  mr-3 border-2  border-[#17A875]  mt-3'>Server Side Code <img className='w-5 ml-3 ' src={open} alt='' /> </button>
                            </a>
                        </div>
                    </div>

                </div>
            </div>
        </div >
    )
}

export default Projects;
